import * as React from "react";
const SvgSpinner = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" strokeWidth=".75rem" stroke="var(--spinner-color, #3F3F3E)" {...props}><circle cx={75} cy={75} r={60} /></svg>;
export default SvgSpinner;